import React from 'react';
import type { SectionProps } from './types';

export const ExpirationSection: React.FC<SectionProps> = ({ data, setFormData }) => (
  <div className="border-b pb-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">Expiration Handling</h3>

    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Expired Message</label>
        <input
          type="text"
          value={data.expiredMessage || 'This offer has ended'}
          onChange={e => setFormData({ ...data, expiredMessage: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
          placeholder="This offer has ended"
        />
      </div>

      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={data.hideWhenExpired || false}
          onChange={e => setFormData({ ...data, hideWhenExpired: e.target.checked })}
          className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
        />
        <span className="text-sm text-gray-700">Hide Component When Expired</span>
      </label>
    </div>
  </div>
);
